document.addEventListener('click',function(e){
  var n=e.target.closest('[data-scroll-next]'),p=e.target.closest('[data-scroll-prev]');
  if(!n&&!p)return; var id=(n||p).getAttribute(n?'data-scroll-next':'data-scroll-prev');
  var el=document.getElementById(id); if(!el)return;
  el.scrollBy({left:(n?1:-1)*Math.round(el.clientWidth*0.85),behavior:'smooth'});
});

// Add-to-cart for nlp-product-card (.pcard) forms.
// These compact cards live in custom nlp-* sections that the theme's per-section
// ProductVariants controller never registers, so theme.js's delegated
// [data-action="add-to-cart"] handler never binds to them (clicking did nothing).
// We add the product via Ajax and then dispatch the theme's own bubbling
// `product:added` event, which the document-level header Cart controller catches
// to refresh + open the mini-cart drawer — mirroring theme.js _addToCart exactly.
// Scoped strictly to .pcard__atc so real product-section forms are untouched;
// capture phase guarantees we run instead of any other delegated click handler.
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.pcard__atc[data-action="add-to-cart"]');
  if (!btn) return;
  var form = btn.closest('form[action*="/cart/add"]');
  if (!form || btn.hasAttribute('disabled')) return;
  e.preventDefault();
  e.stopPropagation();
  var idEl = form.querySelector('[name="id"]');
  if (!idEl || !idEl.value) return;
  var qEl = form.querySelector('[name="quantity"]');
  var qty = qEl ? (parseInt(qEl.value, 10) || 1) : 1;
  btn.setAttribute('disabled', 'disabled');
  document.dispatchEvent(new CustomEvent('theme:loading:start'));
  var addUrl = (window.routes && window.routes.cartAddUrl) || '/cart/add';
  fetch(addUrl + '.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ id: idEl.value, quantity: qty }),
    credentials: 'same-origin'
  }).then(function (r) {
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
    btn.removeAttribute('disabled');
    if (!r.ok) return;
    form.dispatchEvent(new CustomEvent('product:added', {
      bubbles: true,
      detail: { quantity: qty, button: btn }
    }));
  }).catch(function () {
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
    btn.removeAttribute('disabled');
  });
}, true);

// Collection/search grid-list view toggle. theme.js's _changeLayout only
// re-classes .product-item nodes in place, but the redesigned grid renders
// .pcard markup that can't be morphed into the theme's list card client-side.
// Persist the choice to the same collection_layout cart attribute the section
// reads server-side, then reload so Liquid renders the right markup for the
// mode. Capture phase + stopPropagation blocks theme.js's dead in-place
// handler; theme-editor programmatic clicks (designMode) keep theme behavior.
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-action="change-layout"]');
  if (!btn) return;
  if (window.Shopify && window.Shopify.designMode) return;
  e.preventDefault();
  e.stopPropagation();
  if (btn.classList.contains('is-selected')) return;
  var mode = btn.getAttribute('data-layout-mode');
  if (!mode) return;
  document.dispatchEvent(new CustomEvent('theme:loading:start'));
  var cartUrl = (window.routes && window.routes.cartUrl) || '/cart';
  fetch(cartUrl + '/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ attributes: { collection_layout: mode } }),
    credentials: 'same-origin'
  }).then(function () {
    window.location.reload();
  }).catch(function () {
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
  });
}, true);

// Predictive search for the nlp header search bars (desktop + mobile rows).
// Production's Warehouse SearchBar showed live product suggestions while typing;
// the nlp header replaced that markup, so this restores the behavior against
// Shopify's native /search/suggest.json (no theme.js coupling). Renders product
// image + title + price under the bar; plain GET submit still works unchanged.
(function () {
  var forms = [].slice.call(document.querySelectorAll('form.hdr__search'));
  if (!forms.length) return;
  forms.forEach(function (form) {
    var input = form.querySelector('input[name="q"]');
    if (!input) return;
    var panel = document.createElement('div');
    panel.className = 'hdr__suggest';
    panel.hidden = true;
    form.appendChild(panel);
    var timer, ctrl;
    function close() { panel.hidden = true; panel.innerHTML = ''; }
    function render(products, q) {
      panel.innerHTML = '';
      if (!products.length) { close(); return; }
      products.forEach(function (p) {
        var a = document.createElement('a');
        a.className = 'hdr__suggest-item';
        a.href = p.url;
        var img = document.createElement('img');
        img.alt = '';
        img.loading = 'lazy';
        if (p.featured_image && p.featured_image.url) {
          img.src = p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=80';
        }
        var info = document.createElement('span');
        info.className = 'hdr__suggest-info';
        var t = document.createElement('span');
        t.className = 'hdr__suggest-title';
        t.textContent = p.title;
        var pr = document.createElement('span');
        pr.className = 'hdr__suggest-price';
        pr.textContent = p.price ? '$' + p.price : '';
        info.appendChild(t); info.appendChild(pr);
        a.appendChild(img); a.appendChild(info);
        panel.appendChild(a);
      });
      var all = document.createElement('a');
      all.className = 'hdr__suggest-all';
      all.href = '/search?type=product&q=' + encodeURIComponent(q);
      all.textContent = 'View all results →';
      panel.appendChild(all);
      panel.hidden = false;
    }
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      timer = setTimeout(function () {
        if (ctrl) ctrl.abort();
        ctrl = ('AbortController' in window) ? new AbortController() : null;
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
              '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last',
              ctrl ? { signal: ctrl.signal } : undefined)
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) {
            if (!data) return;
            var products = (((data.resources || {}).results || {}).products) || [];
            render(products, q);
          })
          .catch(function () { /* aborted or offline — keep quiet */ });
      }, 250);
    });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
  });
})();

// Desktop nav hover dropdowns. The nav row scrolls horizontally (its overflow would
// clip an absolutely-positioned panel) and the header is sticky (a transformed ancestor
// can trap position:fixed), so each dropdown is detached to <body> and positioned under
// its item on hover. Touch devices skip this entirely — the top link just navigates to
// the category, and the mobile burger menu handles sub-items via slide-in panels.
(function () {
  var wraps = [].slice.call(document.querySelectorAll('.nav__item-wrap[data-nav-dropdown]'));
  if (!wraps.length) return;
  if (window.matchMedia && window.matchMedia('(hover: none)').matches) return;
  var openDD = null;
  wraps.forEach(function (wrap) {
    var dd = wrap.querySelector('.nav__dropdown');
    if (!dd) return;
    document.body.appendChild(dd); // escape the scroll/transform ancestors
    var timer;
    function open() {
      clearTimeout(timer);
      // Single mega panel at a time — close any other open one immediately.
      wraps.forEach(function (w) { if (w !== wrap) w.classList.remove('is-active'); });
      document.querySelectorAll('body > .nav__dropdown.is-open').forEach(function (d) { if (d !== dd) d.classList.remove('is-open'); });
      // Align the panel to the nav's CONTENT box (inside the gutter) so it lines up with
      // the items (both ends), and drop it just below the bar.
      var navInner = document.querySelector('.nav__inner');
      var navBar = document.querySelector('.nav');
      var ir = (navInner || wrap).getBoundingClientRect();
      var br = (navBar || wrap).getBoundingClientRect();
      var padL = 0, padR = 0;
      if (navInner) { var ics = getComputedStyle(navInner); padL = parseFloat(ics.paddingLeft) || 0; padR = parseFloat(ics.paddingRight) || 0; }
      dd.style.left = Math.round(ir.left + padL) + 'px';
      dd.style.width = Math.round(ir.width - padL - padR) + 'px';
      dd.style.top = Math.round(br.bottom) + 'px';
      dd.classList.add('is-open');
      wrap.classList.add('is-active');
      openDD = dd;
    }
    function close() {
      timer = setTimeout(function () {
        dd.classList.remove('is-open');
        wrap.classList.remove('is-active');
        if (openDD === dd) openDD = null;
      }, 130);
    }
    wrap.addEventListener('mouseenter', open);
    wrap.addEventListener('mouseleave', close);
    dd.addEventListener('mouseenter', function () { clearTimeout(timer); });
    dd.addEventListener('mouseleave', close);
  });
  // Close on scroll (the fixed panel would otherwise detach from its moving item).
  window.addEventListener('scroll', function () {
    if (openDD) { openDD.classList.remove('is-open'); openDD = null; }
    wraps.forEach(function (w) { w.classList.remove('is-active'); });
  }, { passive: true });
})();

// Reviews carousel arrows: the header's prev/next buttons drive the Judge.me
// cards-carousel by clicking its (hidden) .jdgm-arrow buttons (arrows[0]=prev,
// arrows[1]=next). Queried live so it survives Judge.me re-renders.
document.addEventListener('click', function (e) {
  var p = e.target.closest('[data-jdgm-prev]'), n = e.target.closest('[data-jdgm-next]');
  if (!p && !n) return;
  var sec = (p || n).closest('.sec');
  var app = sec && sec.querySelector('.nlp-reviews-app');
  if (!app) return;
  var arrows = app.querySelectorAll('.jdgm-arrow');
  if (arrows.length < 2) return;
  (p ? arrows[0] : arrows[1]).click();
});

// In-stock default filter fast path. in-stock-filter-default.liquid redirects
// unfiltered collection/search landings to ?filter.v.availability=1, which
// costs a second full page load on every nav click. Rewriting the href at
// click time lands directly on the filtered URL so that redirect never fires.
// Click time (not DOMContentLoaded) so the sessionStorage opt-out is always
// read fresh and bfcache-restored pages can't carry stale hrefs. The key and
// param checks must mirror the snippet exactly. External entries (SEO, typed
// URLs) still rely on the snippet's redirect; collections over 5,000 products
// ignore the param server-side, so adding it there is harmless.
(function () {
  var OPT_OUT_KEY = 'nlpInStockFilterOptOut';
  var AVAIL_PARAM = 'filter.v.availability';

  function optedOut() {
    try { return sessionStorage.getItem(OPT_OUT_KEY) === '1'; } catch (e) { return false; }
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || optedOut()) return;
    var url;
    try { url = new URL(a.href, window.location.origin); } catch (err) { return; }
    if (url.origin !== window.location.origin) return;
    // Collection roots only (incl. old-style /collections/handle/tag paths) and
    // actual searches; never product URLs nested under a collection.
    var isCollection = /^\/collections\/[^/]+(\/[^/]+)?\/?$/.test(url.pathname) &&
      url.pathname.indexOf('/products/') === -1;
    var isSearch = url.pathname === '/search' && (url.searchParams.get('q') || '').trim() !== '';
    if (!isCollection && !isSearch) return;
    var hasFilter = false;
    url.searchParams.forEach(function (v, k) { if (k.indexOf('filter.') === 0) hasFilter = true; });
    if (hasFilter) return;
    url.searchParams.set(AVAIL_PARAM, '1');
    a.setAttribute('href', url.pathname + url.search);
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !(form instanceof HTMLFormElement) || optedOut()) return;
    if ((form.getAttribute('method') || 'get').toLowerCase() !== 'get') return;
    var action;
    try { action = new URL(form.action || '/search', window.location.origin); } catch (err) { return; }
    if (action.origin !== window.location.origin || action.pathname !== '/search') return;
    var q = form.querySelector('input[name="q"]');
    if (!q || q.value.trim() === '') return;
    if (form.querySelector('[name="' + AVAIL_PARAM + '"]')) return;
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = AVAIL_PARAM;
    input.value = '1';
    form.appendChild(input);
  }, true);
})();
